import React from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';

import './index.scss';
import { scrollTop } from 'utils';
import icon from 'assets/button-icon-left.svg';

const notToLinkFunc = e => e.preventDefault();
const toLinkFunc = () => {};

const NextButton = ({ label, onClick, link = '', valid = false }) => {
   
  const onClickFunc = (e) => {
    scrollTop();
    onClick(e);
  };

  return (
    <Link
      to={link}
      className={clsx('NextButton', { valid })}
      onClick={valid ? toLinkFunc : notToLinkFunc}
    >
      <button
        className="button"
        type="button"
        onClick={valid ? onClickFunc : () => { console.log('no valid'); }}
      >
        {label}
        <img className="nextImage" src={icon} alt="" />
      </button>
    </Link>
  );
};

export default NextButton;